// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import i18n from './i18n'
Vue.prototype.$axios = Axios
Vue.config.productionTip = false


let yufa = {
  apiUrl:'https://fhwqdf.gchao.com/faceshow', //预发
  urlh5:'http://html5.gchao.com',
}
let zhengshi = {
  apiUrl:'https://dhcxzil.facecast.xyz/faceshow', //正式
  urlh5:'https://fsveg.buzzcast.info',
}
let linshi = {
  apiUrl:'https://linshi.facecast.xyz/faceshow', //灰线
  urlh5:'https://huih5.buzzcast.info',
}
let global_huanjing = zhengshi;

Vue.prototype.global_huanjing = global_huanjing;

Axios.defaults.baseURL = global_huanjing.apiUrl;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js